/* GAP personalised poster templates (Ugur, 2026-10-27). Each template is its own card under Gifts: Letter photo collage
   ("DAD" tiles), Heart photo collage, Graduation poster, Photo letters (photos inside the letters of a word) and Photo number
   collage (a 1 or 2 digit number made of photo boxes), Photo initials collage (1 or 2 letters made of photo boxes), and the seasonal Christmas tree collage, Our year in photos,
   Baby's first Christmas and Halloween photo collage, and the story templates (Life timeline, Song lyrics print, Reasons I love you,
   Birth announcement, Birthday newspaper, Family tree, Baby’s first year, Photo grid poster). A card
   first asks for Framed, Dibond, Canvas or Fine art print, then opens this editor instead of the photo picker: one photo per box,
   the template's words and an accent colour, no photo effects. Done draws the finished poster at the chosen size and
   hands it to the configurator as the customer's photo, so preview, print file and cart work as usual; the words, colour
   and the original photos are added to the cart line as properties.
   The template cards are Framed print products; Dibond, Canvas and Fine art use three shared hidden cards ("Photo poster (Dibond)",
   "Photo poster (Canvas)", "Photo poster (Fine art)"). window.gapcfgRules tells the configurator each one's sizes and orientation. */
(function () {
  var CLOUD = 'drvkztoqo', PRESET = 'giftlyartprint_uploads';
  var PAPER = '#F7F4EE', INK = '#2E2B28';
  /* background colours for every template: white first, then light pastels that keep the words and accent colours readable */
  var BGS = [{ n: 'White', h: '#FFFFFF' }, { n: 'Cream', h: '#F7F4EE' }, { n: 'Blush', h: '#F7E6E3' }, { n: 'Sage', h: '#E7EFE5' },
    { n: 'Sky', h: '#E4EDF6' }, { n: 'Lavender', h: '#EDE7F4' }];
  var COLOURS = [{ n: 'Navy', h: '#3F5F86' }, { n: 'Sage', h: '#7F9172' }, { n: 'Blush', h: '#C98F8A' }, { n: 'Gold', h: '#B08D57' }, { n: 'Charcoal', h: '#3A3A3A' }];
  var SQUARE = [[30, 30], [50, 50]], PORTRAIT = [[30, 40], [40, 50], [50, 70]], LANDSCAPE = [[40, 30], [50, 40], [70, 50]];
  var PORTRAIT_S = [[30, 40], [40, 50]];
  var TYPES = [
    { id: 'framed', n: 'Framed print', d: 'Wooden frame with acrylic glass, ready to hang', ic: 'f' },
    { id: 'dibond', n: 'Dibond print', d: '3 mm aluminium panel, modern and frameless', ic: 'd', label: 'Photo poster (Dibond)' },
    { id: 'canvas', n: 'Canvas print', d: 'Canvas stretched on a wooden frame', ic: 'c', label: 'Photo poster (Canvas)' },
    { id: 'art', n: 'Fine art print', d: 'Hahnemühle Photo Rag paper, print only (no frame)', ic: 'a', label: 'Photo poster (Fine art)' },
    { id: 'magnetic', n: 'Magnetic framed print', s: 'Magnetic', d: 'Hangs on a steel plate with magnets, no drilling', ic: 'f', label: 'Photo poster (Magnetic)' }
  ];
  var SCRIPT = '"Great Vibes", cursive', SERIF = '"Playfair Display", Georgia, serif', HEAVY = '"Archivo Black", "Arial Black", sans-serif', SANS = 'Montserrat, Arial, sans-serif';

  /* ---- drawing helpers ---- */
  function cover(g, ph, x, y, w, h) {
    var im = ph.img, k = Math.max(w / im.naturalWidth, h / im.naturalHeight), dw = im.naturalWidth * k, dh = im.naturalHeight * k;
    g.save(); g.beginPath(); g.rect(x, y, w, h); g.clip();
    g.drawImage(im, x + (w - dw) * ph.x / 100, y + (h - dh) * ph.y / 100, dw, dh);
    g.restore();
  }
  function empty(g, x, y, w, h, preview, plus, bg) {
    g.fillStyle = preview ? '#E6E1DA' : (bg || PAPER); g.fillRect(x, y, w, h);
    if (preview && plus !== false) {
      g.fillStyle = '#9C958C'; g.textAlign = 'center'; g.textBaseline = 'middle';
      g.font = '300 ' + Math.round(Math.min(w, h) * 0.4) + 'px Arial'; g.fillText('+', x + w / 2, y + h / 2);
    }
  }
  /* a photo box: the photo, or an empty "+" box in the preview */
  function box(g, st, s, preview) {
    var ph = s.p > -1 ? st.photos[s.p] : null;
    if (ph) cover(g, ph, s.x, s.y, s.w, s.h); else empty(g, s.x, s.y, s.w, s.h, preview, true, st.bg.h);
  }
  /* one line of text, made smaller when it is wider than maxW */
  function line(g, text, font, size, x, y, maxW, colour) {
    g.font = font.replace('SIZE', Math.round(size) + 'px');
    var w = g.measureText(text).width;
    if (w > maxW) g.font = font.replace('SIZE', Math.round(size * maxW / w) + 'px');
    g.fillStyle = colour || INK; g.fillText(text, x, y);
  }
  function heart(g, cx, cy, hs, colour) {
    g.fillStyle = colour; g.beginPath();
    g.moveTo(cx, cy + hs * 1.1);
    g.bezierCurveTo(cx - hs * 1.6, cy, cx - hs * 0.9, cy - hs * 1.1, cx, cy - hs * 0.3);
    g.bezierCurveTo(cx + hs * 0.9, cy - hs * 1.1, cx + hs * 1.6, cy, cx, cy + hs * 1.1);
    g.fill();
  }
  function names(v) { return v.split(',').map(function (s) { return s.trim(); }).filter(Boolean).join('  •  '); }
  function slot(x, y, w, h, k, p) { return { x: x, y: y, w: w, h: h, k: k, p: p }; }
  /* each digit on a 3 x 5 grid of photo boxes, 7 to 12 boxes per digit */
  var DIGITS = {
    0: ['XXX', 'X.X', 'X.X', 'X.X', 'XXX'], 1: ['XX.', '.X.', '.X.', '.X.', 'XXX'], 2: ['XXX', '..X', 'XXX', 'X..', 'XXX'],
    3: ['XXX', '..X', 'XXX', '..X', 'XXX'], 4: ['X.X', 'X.X', 'XXX', '..X', '..X'], 5: ['XXX', 'X..', 'XXX', '..X', 'XXX'],
    6: ['XXX', 'X..', 'XXX', 'X.X', 'XXX'], 7: ['XXX', '..X', '..X', '..X', '..X'], 8: ['XXX', 'X.X', '.X.', 'X.X', 'XXX'],
    9: ['XXX', 'X.X', 'XXX', '..X', 'XXX']
  };
  function numStr(st) { return (st.v.num || '1').slice(0, 2); }
  function numCells(st) { var c = []; numStr(st).split('').forEach(function (d, i) { DIGITS[d].forEach(function (row, r) { for (var k = 0; k < 3; k++) if (row.charAt(k) === 'X') c.push({ d: i, r: r, c: k }); }); }); return c; }
  /* a template's sizes and orientation can depend on what the customer typed (the number collage) */
  function sizesOf(t) { return typeof t.sizes === 'function' ? t.sizes(STATE[t.id]) : t.sizes; }
  function orientOf(t) { return typeof t.orient === 'function' ? t.orient(STATE[t.id]) : t.orient; }

  /* ---- templates: fields, how many photos, sizes, and how the poster is drawn. render() returns the photo boxes ---- */
  var TPL = [
    {
      id: 'letter', name: 'Letter photo collage', hint: '6 photos and your words', sizes: SQUARE, orient: 's',
      lead: 'Three letters, six photos and a message. Square, 30×30 or 50×50 cm.',
      fields: [
        { k: 'word', l: 'Word (3 letters)', v: 'DAD', max: 3, letters: 3 },
        { k: 'msg1', l: 'Message line 1', v: 'You mean the world to us,', max: 32 },
        { k: 'msg2', l: 'Message line 2', v: 'we love you Dad.', max: 32 },
        { k: 'names', l: 'Names (separate with commas)', v: 'Charlotte, Dad, Jemma', max: 48 }
      ],
      need: function () { return 6; }, cap: function () { return 6; },
      render: function (g, W, H, st, preview) {
        var m = W * 0.1, textH = W * 0.31;
        var G = Math.min(W - 2 * m, H - 1.4 * m - textH), gap = G * 0.025, t = (G - 2 * gap) / 3;
        var x0 = (W - G) / 2, y0 = Math.max(m * 0.8, (H - G - textH) / 2), slots = [], k = 0, v = st.v;
        for (var i = 0; i < 9; i++) {
          var x = x0 + (i % 3) * (t + gap), y = y0 + Math.floor(i / 3) * (t + gap);
          if (i % 4 === 0) {
            g.fillStyle = st.colour.h; g.fillRect(x, y, t, t);
            g.fillStyle = '#fff'; g.textAlign = 'center'; g.textBaseline = 'middle';
            g.font = '400 ' + Math.round(t * 0.62) + 'px ' + SERIF;
            g.fillText(v.word.charAt(i / 4) || '', x + t / 2, y + t * 0.53);
          } else { var s = slot(x, y, t, t, k, k); box(g, st, s, preview); slots.push(s); k++; }
        }
        var ty = y0 + G + W * 0.07, fs = W * 0.05;
        g.textAlign = 'center'; g.textBaseline = 'alphabetic';
        line(g, v.msg1, 'SIZE ' + SCRIPT, fs, W / 2, ty, W * 0.84);
        line(g, v.msg2, 'SIZE ' + SCRIPT, fs, W / 2, ty + fs * 1.35, W * 0.84);
        var hy = ty + fs * 2.2; heart(g, W / 2, hy, W * 0.017, st.colour.h);
        line(g, names(v.names), '400 SIZE ' + SERIF, W * 0.034, W / 2, hy + W * 0.06, W * 0.84);
        return slots;
      }
    },
    {
      id: 'heart', name: 'Heart photo collage', hint: '10 to 27 photos and your words', sizes: SQUARE, orient: 's', repeat: true,
      lead: 'A heart made of your photos, with a title under it. Square, 30×30 or 50×50 cm.',
      fields: [
        { k: 'title', l: 'Title', v: 'Mum & Dad', max: 28 },
        { k: 'sub', l: 'Line under the title', v: 'Happy anniversary  •  25 years', max: 40 }
      ],
      need: function () { return 10; }, cap: function () { return 27; },
      render: function (g, W, H, st, preview) {
        var MASK = ['.XX.XX.', 'XXXXXXX', 'XXXXXXX', '.XXXXX.', '..XXX..', '...X...'];
        var G = W * 0.74, gap = G * 0.014, t = (G - 6 * gap) / 7, gh = 6 * t + 5 * gap, textH = W * 0.2;
        var x0 = (W - G) / 2, y0 = Math.max(W * 0.07, (H - gh - textH) / 2), slots = [], k = 0;
        var used = st.photos.map(function (p, i) { return p ? i : -1; }).filter(function (i) { return i > -1; });
        MASK.forEach(function (row, r) {
          for (var c = 0; c < 7; c++) {
            if (row.charAt(c) !== 'X') continue;
            var s = slot(x0 + c * (t + gap), y0 + r * (t + gap), t, t, k, used.length ? used[k % used.length] : -1);
            box(g, st, s, preview); slots.push(s); k++;
          }
        });
        var ty = y0 + gh + W * 0.1;
        g.textAlign = 'center'; g.textBaseline = 'alphabetic';
        line(g, st.v.title, 'SIZE ' + SCRIPT, W * 0.08, W / 2, ty, W * 0.84);
        line(g, st.v.sub.toUpperCase(), '600 SIZE ' + SERIF, W * 0.03, W / 2, ty + W * 0.065, W * 0.84, st.colour.h);
        return slots;
      }
    },
    {
      id: 'grad', name: 'Graduation poster', hint: '4 photos and your words', sizes: PORTRAIT, orient: 'v',
      lead: 'One large photo, three small ones and the graduate’s details. Portrait, 30×40, 40×50 or 50×70 cm.',
      fields: [
        { k: 'head', l: 'Heading', v: 'Congratulations', max: 24 },
        { k: 'name', l: 'Graduate’s name', v: 'Emily Johnson', max: 30 },
        { k: 'year', l: 'Year line', v: 'Class of 2026', max: 24 },
        { k: 'school', l: 'Course and school', v: 'BSc Psychology  •  University of Kent', max: 48 }
      ],
      need: function () { return 4; }, cap: function () { return 4; },
      render: function (g, W, H, st, preview) {
        var m = W * 0.1, cw = W - 2 * m, gap = W * 0.02, t = (cw - 2 * gap) / 3;
        /* heading, large photo, then name / year / school on their own baselines with room for the script's loops.
           The large photo keeps the same shape at every size, so the customer's crop does not change; the design is centred */
        var headB = W * 0.042, nameB = W * 0.12, yearB = W * 0.078, schoolB = W * 0.05, after = W * 0.045, mainH = cw * 0.6;
        var total = headB + W * 0.03 + mainH + nameB + yearB + schoolB + after + t, top = Math.max(H * 0.04, (H - total) / 2);
        var y = top + headB;
        g.textAlign = 'center'; g.textBaseline = 'alphabetic';
        line(g, st.v.head.toUpperCase(), '600 SIZE ' + SERIF, W * 0.042, W / 2, y, cw, st.colour.h);
        y += W * 0.03;
        var s0 = slot(m, y, cw, mainH, 0, 0); box(g, st, s0, preview);
        y += mainH + nameB;
        line(g, st.v.name, 'SIZE ' + SCRIPT, W * 0.1, W / 2, y, cw);
        y += yearB;
        line(g, st.v.year.toUpperCase(), '600 SIZE ' + SERIF, W * 0.04, W / 2, y, cw, st.colour.h);
        y += schoolB;
        line(g, st.v.school, '400 SIZE ' + SERIF, W * 0.032, W / 2, y, cw);
        y += after;
        var slots = [s0];
        for (var i = 0; i < 3; i++) { var s = slot(m + i * (t + gap), y, t, t, i + 1, i + 1); box(g, st, s, preview); slots.push(s); }
        return slots;
      }
    },
    {
      id: 'letters', name: 'Photo letters', hint: '2 photos for each letter', sizes: LANDSCAPE, orient: 'h',
      lead: 'Your word with two photos inside every letter. Landscape, 40×30, 50×40 or 70×50 cm.',
      fields: [
        { k: 'word', l: 'Word (2 to 6 letters)', v: 'DAD', max: 6, letters: 2 },
        { k: 'msg', l: 'Message', v: 'The best dad in the world', max: 40 },
        { k: 'names', l: 'Names (separate with commas)', v: 'Charlotte, Jemma', max: 48 }
      ],
      need: function (st) { return 2 * Math.max(2, st.v.word.length); }, cap: function (st) { return 2 * Math.max(2, st.v.word.length); },
      render: function (g, W, H, st, preview) {
        var word = st.v.word || 'AB', n = word.length, gap = W * 0.015, maxW = W * 0.86, maxH = H * 0.56;
        g.font = '100px ' + HEAVY;
        var ms = word.split('').map(function (ch) { return g.measureText(ch); });
        var wSum = ms.reduce(function (a, x) { return a + x.actualBoundingBoxLeft + x.actualBoundingBoxRight; }, 0);
        var hMax = Math.max.apply(null, ms.map(function (x) { return x.actualBoundingBoxAscent + x.actualBoundingBoxDescent; }));
        var size = 100 * Math.min((maxW - gap * (n - 1)) / wSum, maxH / hMax), sc = size / 100;
        var textH = W * 0.12, gh = hMax * sc, y0 = Math.max(H * 0.06, (H - gh - textH) / 2), x = (W - wSum * sc - gap * (n - 1)) / 2;
        var slots = [];
        word.split('').forEach(function (ch, i) {
          var bw = (ms[i].actualBoundingBoxLeft + ms[i].actualBoundingBoxRight) * sc, bh = gh;
          var bx = Math.round(x), by = Math.round(y0), cw = Math.max(1, Math.ceil(bw)), chh = Math.max(1, Math.ceil(bh));
          /* the two photos are drawn on their own canvas and cut to the letter's shape */
          var c = document.createElement('canvas'); c.width = cw; c.height = chh;
          var o = c.getContext('2d');
          var a = slot(0, 0, cw, chh / 2, 2 * i, 2 * i), b = slot(0, chh / 2, cw, chh - chh / 2, 2 * i + 1, 2 * i + 1);
          [a, b].forEach(function (s, j) {
            var ph = st.photos[s.p];
            if (ph) cover(o, ph, s.x, s.y, s.w, s.h); else { o.fillStyle = preview ? (j ? '#D6D0C7' : '#E6E1DA') : '#E6E1DA'; o.fillRect(s.x, s.y, s.w, s.h); }
          });
          o.globalCompositeOperation = 'destination-in';
          o.font = Math.round(size) + 'px ' + HEAVY; o.textBaseline = 'alphabetic'; o.textAlign = 'left'; o.fillStyle = '#000';
          o.fillText(ch, ms[i].actualBoundingBoxLeft * sc, (hMax - ms[i].actualBoundingBoxDescent) * sc);
          g.drawImage(c, bx, by);
          slots.push(slot(bx, by, cw, chh / 2, 2 * i, 2 * i), slot(bx, by + chh / 2, cw, chh - chh / 2, 2 * i + 1, 2 * i + 1));
          x += bw + gap;
        });
        var ty = y0 + gh + W * 0.065;
        g.textAlign = 'center'; g.textBaseline = 'alphabetic';
        line(g, st.v.msg, 'SIZE ' + SCRIPT, W * 0.045, W / 2, ty, W * 0.84);
        line(g, names(st.v.names).toUpperCase(), '600 SIZE ' + SERIF, W * 0.022, W / 2, ty + W * 0.045, W * 0.84, st.colour.h);
        return slots;
      }
    }
  ];
  TPL.push({
    id: 'number', name: 'Photo number collage', hint: '6 to 12 photos for each digit', max: 24,
    sizes: function (st) { return numStr(st).length > 1 ? SQUARE : PORTRAIT_S; },
    orient: function (st) { return numStr(st).length > 1 ? 's' : 'v'; },
    allSizes: SQUARE.concat(PORTRAIT_S),
    lead: 'Your number made of photos, with a message, name and date. One digit: portrait, 30×40 or 40×50 cm. Two digits: square, 30×30 or 50×50 cm.',
    fields: [
      { k: 'num', l: 'Number (1 or 2 digits)', v: '1', max: 2, digits: 1 },
      { k: 'title', l: 'Message', v: 'Happy First Birthday', max: 32 },
      { k: 'name', l: 'Name', v: 'Lucy Maddocks', max: 28 },
      { k: 'date', l: 'Date', v: '21.03.2023', max: 20 }
    ],
    need: function (st) { return numCells(st).length; }, cap: function (st) { return numCells(st).length; },
    render: function (g, W, H, st, preview) {
      var n = numStr(st).length, cols = 4 * n - 1, top = H * 0.08, textH = W * 0.27;
      var availH = H - top - textH - H * 0.04, t = Math.min(W * (n > 1 ? 0.76 : 0.5) / cols, availH / 5), gap = t * 0.06;
      var gw = cols * t - gap, gh = 5 * t - gap, x0 = (W - gw) / 2, y0 = top + Math.max(0, (availH - gh) / 2), slots = [];
      numCells(st).forEach(function (q, k) {
        var s = slot(x0 + (q.d * 4 + q.c) * t, y0 + q.r * t, t - gap, t - gap, k, k); box(g, st, s, preview); slots.push(s);
      });
      var ty = y0 + gh + W * 0.11;
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.title, 'SIZE ' + SCRIPT, W * 0.075, W / 2, ty, W * 0.84);
      line(g, st.v.name.toUpperCase(), '700 SIZE ' + SANS, W * 0.05, W / 2, ty + W * 0.075, W * 0.84, st.colour.h);
      line(g, st.v.date, '400 SIZE ' + SANS, W * 0.032, W / 2, ty + W * 0.125, W * 0.84);
      return slots;
    }
  });
  /* each letter is the real letter shape (Uğur, 2026-10-28): cut into 4 rows, a wide row in two slanted pieces, one photo per piece */
  var LCACHE = {};
  /* true only once the letter font has really loaded (check() also says yes while the font's stylesheet has not arrived yet) */
  function fontOk() {
    if (!document.fonts || !document.fonts.forEach) return true;
    var ok = false; document.fonts.forEach(function (f) { if (/Archivo Black/.test(f.family) && f.status === 'loaded') ok = true; });
    return ok;
  }
  function letterCells(ch) {
    if (LCACHE[ch]) return LCACHE[ch];
    var F = 400, c = document.createElement('canvas'), o = c.getContext('2d');
    o.font = F + 'px ' + HEAVY;
    var m = o.measureText(ch), bw = Math.ceil(m.actualBoundingBoxLeft + m.actualBoundingBoxRight), bh = Math.ceil(m.actualBoundingBoxAscent + m.actualBoundingBoxDescent);
    if (!bw || !bh) return { cells: [], ar: 0.7, bh: 1 };
    c.width = bw; c.height = bh; o.font = F + 'px ' + HEAVY; o.textBaseline = 'alphabetic'; o.fillStyle = '#000';
    o.fillText(ch, m.actualBoundingBoxLeft, m.actualBoundingBoxAscent);
    var d = o.getImageData(0, 0, bw, bh).data;
    function inG(x, y) { x = x | 0; y = y | 0; return x >= 0 && y >= 0 && x < bw && y < bh && d[(y * bw + x) * 4 + 3] > 128; }
    var rows = 4, rh = bh / rows, cells = [];
    for (var r = 0; r < rows; r++) {
      var ya = r * rh, yb = ya + rh, colN = [], tot = 0;
      for (var x = 0; x < bw; x += 2) { var cnt = 0; for (var y = ya + 1; y < yb; y += 2) if (inG(x, y)) cnt++; colN.push(cnt); tot += cnt; }
      var xs = [[0, 0]];
      /* a wide row is cut in two: straight down the empty space between two strokes when there is one,
         otherwise where it holds half of the letter (only for a long bar, so no thin slivers) */
      var half = 0, ci = 0, best = -1, bestD = 1e9;
      for (var i = 0; i < colN.length; i++) { half += colN[i]; if (half * 2 >= tot) { ci = i; break; } }
      for (var g0 = 1; g0 < colN.length; g0++) {
        if (colN[g0] || !colN[g0 - 1]) continue;
        var g1 = g0; while (g1 < colN.length && !colN[g1]) g1++;
        if (g1 < colN.length && Math.abs((g0 + g1) / 2 - ci) < bestD) { bestD = Math.abs((g0 + g1) / 2 - ci); best = g0 + g1; }
      }
      if (best > -1 && tot * 4 > rh * rh * 1.5) xs.push([best, best]);
      else if (tot * 4 > rh * rh * 2.4) { var sl = (r % 2 ? 1 : -1) * rh * 0.12; xs.push([ci * 2 - sl, ci * 2 + sl]); }
      xs.push([bw, bw]);
      for (var j = 0; j < xs.length - 1; j++) {
        var p0 = xs[j], q0 = xs[j + 1], n = 0, sx = 0, sy = 0;
        for (var yy = ya + 1; yy < yb; yy += 3) {
          var t = (yy - ya) / rh, xl = p0[0] + (p0[1] - p0[0]) * t, xr = q0[0] + (q0[1] - q0[0]) * t;
          for (var xx = Math.max(0, xl); xx < Math.min(bw, xr); xx += 3) if (inG(xx, yy)) { n++; sx += xx; sy += yy; }
        }
        if (!n) continue;
        cells.push({ poly: [[p0[0] / bw, ya / bh], [q0[0] / bw, ya / bh], [q0[1] / bw, yb / bh], [p0[1] / bw, yb / bh]], c: [sx / n / bw, sy / n / bh] });
      }
    }
    var res = { cells: cells, ar: bw / bh, bh: bh };
    if (fontOk()) LCACHE[ch] = res;
    return res;
  }
  function initStr(st) { return (st.v.word || 'A').replace(/[^A-Z]/g, '').slice(0, 2) || 'A'; }
  function initCount(st) { return initStr(st).split('').reduce(function (a, ch) { return a + (fontOk() ? letterCells(ch).cells.length : 8); }, 0); }
  function pathOf(g, pts) { g.beginPath(); pts.forEach(function (p, i) { if (i) g.lineTo(p[0], p[1]); else g.moveTo(p[0], p[1]); }); g.closePath(); }
  TPL.push({
    id: 'initials', name: 'Photo initials collage', hint: 'About 8 photos for each letter', max: 16,
    sizes: function (st) { return initStr(st).length > 1 ? SQUARE : PORTRAIT_S; },
    orient: function (st) { return initStr(st).length > 1 ? 's' : 'v'; },
    allSizes: SQUARE.concat(PORTRAIT_S),
    lead: 'Your initials made of photos, with a message, names and date. One letter: portrait, 30×40 or 40×50 cm. Two letters: square, 30×30 or 50×50 cm.',
    fields: [
      { k: 'word', l: 'Initials (1 or 2 letters)', v: 'AD', max: 2, letters: 1 },
      { k: 'title', l: 'Message', v: 'Forever & Always', max: 32 },
      { k: 'name', l: 'Names', v: 'Adam & Daisy', max: 28 },
      { k: 'date', l: 'Date', v: '14.02.2026', max: 20 }
    ],
    need: initCount, cap: initCount,
    render: function (g, W, H, st, preview) {
      var word = initStr(st).split(''), L = word.map(letterCells), n = word.length, top = H * 0.07, textH = W * 0.27;
      var availH = H - top - textH - H * 0.03, maxW = W * (n > 1 ? 0.86 : 0.7), gapK = 0.1;
      var sumAr = L.reduce(function (a, l) { return a + l.ar; }, 0), maxBh = Math.max.apply(null, L.map(function (l) { return l.bh; }));
      var gh = Math.min(availH, maxW / (sumAr * 1 + gapK * (n - 1))), gap = gh * gapK, line2 = Math.max(2, gh * 0.012);
      var x = (W - (gh * sumAr + gap * (n - 1))) / 2, y0 = Math.max(top, (H - gh - W * 0.24) / 2), slots = [], k = 0;
      word.forEach(function (ch, i) {
        var l = L[i], lh = gh * l.bh / maxBh, lw = gh * l.ar * l.bh / maxBh, bx = Math.round(x), by = Math.round(y0 + gh - lh);
        var cw = Math.max(1, Math.ceil(lw)), chh = Math.max(1, Math.ceil(lh));
        /* the pieces are drawn on their own canvas and then cut to the letter's shape */
        var c = document.createElement('canvas'); c.width = cw; c.height = chh;
        var o = c.getContext('2d');
        l.cells.forEach(function (cell) {
          var pts = cell.poly.map(function (p) { return [p[0] * cw, p[1] * chh]; });
          var xs = pts.map(function (p) { return p[0]; }), ys = pts.map(function (p) { return p[1]; });
          var sx = Math.max(0, Math.min.apply(null, xs)), sy = Math.min.apply(null, ys), sw = Math.min(cw, Math.max.apply(null, xs)) - sx, sh = Math.max.apply(null, ys) - sy;
          var s = slot(bx + sx, by + sy, sw, sh, k, k), ph = st.photos[k];
          s.poly = pts.map(function (p) { return [bx + p[0], by + p[1]]; });
          o.save(); pathOf(o, pts); o.clip();
          if (ph) cover(o, ph, sx, sy, sw, sh); else { o.fillStyle = preview ? '#E6E1DA' : (st.bg.h || PAPER); o.fillRect(sx, sy, sw, sh); }
          o.restore();
          if (!ph && preview) {
            o.fillStyle = '#9C958C'; o.textAlign = 'center'; o.textBaseline = 'middle';
            o.font = '300 ' + Math.round(Math.min(gh * 0.09, sw * 0.45)) + 'px Arial'; o.fillText('+', cell.c[0] * cw, cell.c[1] * chh);
          }
          slots.push(s); k++;
        });
        /* thin lines between the pieces in the background colour */
        o.strokeStyle = st.bg.h || PAPER; o.lineWidth = line2; o.lineJoin = 'round';
        l.cells.forEach(function (cell) { pathOf(o, cell.poly.map(function (p) { return [p[0] * cw, p[1] * chh]; })); o.stroke(); });
        o.globalCompositeOperation = 'destination-in';
        /* the letter is fitted inside its box, so it is never cut; a little smaller is fine */
        o.textBaseline = 'alphabetic'; o.textAlign = 'left'; o.fillStyle = '#000'; o.font = '400px ' + HEAVY;
        var m = o.measureText(ch), f = Math.min(cw / (m.actualBoundingBoxLeft + m.actualBoundingBoxRight), chh / (m.actualBoundingBoxAscent + m.actualBoundingBoxDescent));
        o.font = 400 * f + 'px ' + HEAVY; m = o.measureText(ch);
        o.fillText(ch, (cw - m.actualBoundingBoxLeft - m.actualBoundingBoxRight) / 2 + m.actualBoundingBoxLeft, (chh - m.actualBoundingBoxAscent - m.actualBoundingBoxDescent) / 2 + m.actualBoundingBoxAscent);
        g.drawImage(c, bx, by);
        x += lw + gap;
      });
      var ty = y0 + gh + W * 0.11;
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.title, 'SIZE ' + SCRIPT, W * 0.075, W / 2, ty, W * 0.84);
      line(g, st.v.name.toUpperCase(), '700 SIZE ' + SANS, W * 0.05, W / 2, ty + W * 0.075, W * 0.84, st.colour.h);
      line(g, st.v.date, '400 SIZE ' + SANS, W * 0.032, W / 2, ty + W * 0.125, W * 0.84);
      return slots;
    }
  });
  /* ---- seasonal templates (Ugur, 2026-10-27): three for Christmas and one for Halloween ---- */
  var XMAS = [{ n: 'Red', h: '#A8323A' }, { n: 'Green', h: '#2F5D45' }, { n: 'Gold', h: '#B08D57' }, { n: 'Navy', h: '#3F5F86' }, { n: 'Charcoal', h: '#3A3A3A' }];
  var SPOOKY = [{ n: 'Black', h: '#26221F' }, { n: 'Orange', h: '#D2691E' }, { n: 'Purple', h: '#5B3F7A' }, { n: 'Green', h: '#4E6B3A' }];
  function star(g, cx, cy, r, colour) {
    g.fillStyle = colour; g.beginPath();
    for (var i = 0; i < 10; i++) { var a = -Math.PI / 2 + i * Math.PI / 5, rr = i % 2 ? r * 0.45 : r; g.lineTo(cx + rr * Math.cos(a), cy + rr * Math.sin(a)); }
    g.closePath(); g.fill();
  }
  /* photo boxes laid out from a mask; when there are fewer photos than boxes they repeat, like the heart */
  function used(st) { return st.photos.map(function (p, i) { return p ? i : -1; }).filter(function (i) { return i > -1; }); }
  TPL.push({
    id: 'tree', name: 'Christmas tree collage', hint: '10 to 15 photos and your words', sizes: PORTRAIT_S, orient: 'v', repeat: true, colours: XMAS,
    lead: 'A Christmas tree made of your photos, with a star on top. Portrait, 30×40 or 40×50 cm.',
    fields: [
      { k: 'title', l: 'Title', v: 'Our Christmas 2026', max: 28 },
      { k: 'name', l: 'Family name', v: 'The Johnson Family', max: 32 }
    ],
    need: function () { return 10; }, cap: function () { return 15; },
    render: function (g, W, H, st, preview) {
      var G = W * 0.7, gap = G * 0.02, t = (G - 4 * gap) / 5, th = 5 * t + 4 * gap, starR = t * 0.42, trunk = t * 0.45;
      var total = starR * 2.2 + th + trunk + W * 0.3, y0 = Math.max(H * 0.05, (H - total) / 2) + starR * 2.2;
      var slots = [], k = 0, u = used(st);
      star(g, W / 2, y0 - starR * 1.15, starR, '#C9A227');
      for (var r = 0; r < 5; r++) {
        var n = r + 1, x0 = (W - (n * t + (n - 1) * gap)) / 2;
        for (var c = 0; c < n; c++) {
          var s = slot(x0 + c * (t + gap), y0 + r * (t + gap), t, t, k, u.length ? u[k % u.length] : -1);
          box(g, st, s, preview); slots.push(s); k++;
        }
      }
      g.fillStyle = '#7A5A3F'; g.fillRect(W / 2 - t * 0.3, y0 + th + gap, t * 0.6, trunk);
      var ty = y0 + th + gap + trunk + W * 0.13;
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.title, 'SIZE ' + SCRIPT, W * 0.085, W / 2, ty, W * 0.84);
      line(g, st.v.name.toUpperCase(), '600 SIZE ' + SERIF, W * 0.036, W / 2, ty + W * 0.075, W * 0.84, st.colour.h);
      return slots;
    }
  });
  var MONTHS = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
  TPL.push({
    id: 'year', name: 'Our year in photos', hint: '12 photos, one for each month', sizes: SQUARE, orient: 's', colours: XMAS,
    lead: 'Twelve photos, one for every month of your year. Square, 30×30 or 50×50 cm.',
    fields: [
      { k: 'title', l: 'Title', v: 'Our Year 2026', max: 24 },
      { k: 'name', l: 'Family name', v: 'The Johnson Family', max: 32 },
      { k: 'msg', l: 'Message', v: 'Merry Christmas and thank you for every moment', max: 56 }
    ],
    need: function () { return 12; }, cap: function () { return 12; },
    render: function (g, W, H, st, preview) {
      var G = W * 0.74, gap = W * 0.018, t = (G - 3 * gap) / 4, lab = W * 0.034, row = t + lab + W * 0.012;
      var gy = W * 0.17, x0 = (W - G) / 2, slots = [];
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.title, 'SIZE ' + SCRIPT, W * 0.075, W / 2, W * 0.12, W * 0.84);
      for (var i = 0; i < 12; i++) {
        var x = x0 + (i % 4) * (t + gap), y = gy + Math.floor(i / 4) * row;
        var s = slot(x, y, t, t, i, i); box(g, st, s, preview); slots.push(s);
        g.textAlign = 'center'; line(g, MONTHS[i], '600 SIZE ' + SANS, W * 0.016, x + t / 2, y + t + lab * 0.72, t, st.colour.h);
      }
      var ty = gy + 3 * row + W * 0.05;
      line(g, st.v.name.toUpperCase(), '600 SIZE ' + SERIF, W * 0.034, W / 2, ty, W * 0.84, st.colour.h);
      line(g, st.v.msg, 'italic 400 SIZE ' + SERIF, W * 0.026, W / 2, ty + W * 0.045, W * 0.84);
      return slots;
    }
  });
  TPL.push({
    id: 'baby', name: 'Baby’s first Christmas', hint: '4 photos and your words', sizes: PORTRAIT_S, orient: 'v', colours: XMAS,
    lead: 'One large photo, three small ones, the baby’s name and the year. Portrait, 30×40 or 40×50 cm.',
    fields: [
      { k: 'title', l: 'Title', v: 'Baby’s First Christmas', max: 28 },
      { k: 'name', l: 'Baby’s name', v: 'Oliver James', max: 28 },
      { k: 'year', l: 'Year', v: '2026', max: 12 }
    ],
    need: function () { return 4; }, cap: function () { return 4; },
    render: function (g, W, H, st, preview) {
      var m = W * 0.1, cw = W - 2 * m, gap = W * 0.02, t = (cw - 2 * gap) / 3;
      /* the large photo keeps the same shape at every size (no new crop when the size changes); the design is centred */
      var titleB = W * 0.085, nameB = W * 0.085, yearB = W * 0.06, after = W * 0.04, mainH = cw * 0.68;
      var total = titleB + W * 0.035 + mainH + nameB + yearB + after + t, top = Math.max(H * 0.04, (H - total) / 2);
      var y = top + titleB;
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.title, 'SIZE ' + SCRIPT, W * 0.085, W / 2, y, cw);
      y += W * 0.035;
      var s0 = slot(m, y, cw, mainH, 0, 0); box(g, st, s0, preview);
      y += mainH + nameB;
      line(g, st.v.name.toUpperCase(), '700 SIZE ' + SANS, W * 0.055, W / 2, y, cw, st.colour.h);
      y += yearB;
      line(g, st.v.year, '400 SIZE ' + SERIF, W * 0.036, W / 2, y, cw);
      g.font = '400 ' + Math.round(W * 0.036) + 'px ' + SERIF;
      var yw = g.measureText(st.v.year).width / 2 + W * 0.04;
      star(g, W / 2 - yw, y - W * 0.012, W * 0.014, st.colour.h); star(g, W / 2 + yw, y - W * 0.012, W * 0.014, st.colour.h);
      y += after;
      var slots = [s0];
      for (var i = 0; i < 3; i++) { var s = slot(m + i * (t + gap), y, t, t, i + 1, i + 1); box(g, st, s, preview); slots.push(s); }
      return slots;
    }
  });
  TPL.push({
    id: 'pumpkin', name: 'Halloween photo collage', hint: '12 to 39 photos and your words', sizes: SQUARE, orient: 's', repeat: true, colours: SPOOKY,
    lead: 'A jack-o’-lantern made of your photos. Square, 30×30 or 50×50 cm.',
    fields: [
      { k: 'title', l: 'Title', v: 'Happy Halloween', max: 24 },
      { k: 'sub', l: 'Line under the title', v: 'The Johnson Family  •  2026', max: 40 }
    ],
    need: function () { return 12; }, cap: function () { return 39; },
    render: function (g, W, H, st, preview) {
      /* X = photo, F = the face (eyes, nose and mouth in the accent colour), S = stem */
      var MASK = ['....S....', '.XXXXXXX.', 'XXFXXXFXX', 'XFFFXFFFX', 'XXXXXXXXX', 'XFFFFFFFX', 'XXFXFXFXX', '..XXXXX..'];
      var G = W * 0.72, gap = G * 0.012, t = (G - 8 * gap) / 9, gh = 8 * t + 7 * gap, textH = W * 0.2;
      var x0 = (W - G) / 2, y0 = Math.max(W * 0.07, (H - gh - textH) / 2), slots = [], k = 0, u = used(st);
      MASK.forEach(function (row, r) {
        for (var c = 0; c < 9; c++) {
          var ch = row.charAt(c), x = x0 + c * (t + gap), y = y0 + r * (t + gap);
          if (ch === 'S') { g.fillStyle = '#4E6B3A'; g.fillRect(x + t * 0.3, y + t * 0.25, t * 0.4, t * 0.75 + gap); }
          else if (ch === 'F') { g.fillStyle = st.colour.h; g.fillRect(x, y, t, t); }
          else if (ch === 'X') { var s = slot(x, y, t, t, k, u.length ? u[k % u.length] : -1); box(g, st, s, preview); slots.push(s); k++; }
        }
      });
      var ty = y0 + gh + W * 0.1;
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.title, 'SIZE ' + SCRIPT, W * 0.08, W / 2, ty, W * 0.84);
      line(g, st.v.sub.toUpperCase(), '600 SIZE ' + SERIF, W * 0.03, W / 2, ty + W * 0.065, W * 0.84, st.colour.h);
      return slots;
    }
  });
  /* ---- story templates (2026-10-28): the occasion pages' designs that had no template yet ---- */
  /* text broken into lines that fit maxW, at most max lines */
  function wrapText(g, text, maxW, max) {
    var out = [], cur = '';
    String(text || '').split(/\s+/).filter(Boolean).forEach(function (w) {
      var t = cur ? cur + ' ' + w : w;
      if (g.measureText(t).width > maxW && cur) { out.push(cur); cur = w; } else cur = t;
    });
    if (cur) out.push(cur);
    return out.slice(0, max || 99);
  }
  /* a round photo box with a thin ring in the accent colour */
  function roundBox(g, st, s, preview) {
    var r = s.w / 2;
    g.save(); g.beginPath(); g.arc(s.x + r, s.y + r, r, 0, Math.PI * 2); g.clip(); box(g, st, s, preview); g.restore();
    g.strokeStyle = st.colour.h; g.lineWidth = Math.max(2, s.w * 0.03);
    g.beginPath(); g.arc(s.x + r, s.y + r, r, 0, Math.PI * 2); g.stroke();
  }
  TPL.push({
    id: 'timeline', name: 'Life timeline', hint: '5 photos and your years', sizes: LANDSCAPE, orient: 'h',
    lead: 'Five photos along a line, each with its own year. Landscape, 40×30, 50×40 or 70×50 cm.',
    fields: [
      { k: 'title', l: 'Title', v: 'Our story', max: 28 },
      { k: 'y1', l: 'Photo 1 label', v: '2010', max: 16 }, { k: 'y2', l: 'Photo 2 label', v: '2014', max: 16 },
      { k: 'y3', l: 'Photo 3 label', v: '2018', max: 16 }, { k: 'y4', l: 'Photo 4 label', v: '2021', max: 16 },
      { k: 'y5', l: 'Photo 5 label', v: '2026', max: 16 },
      { k: 'sub', l: 'Line at the bottom', v: 'The Johnson Family', max: 40 }
    ],
    need: function () { return 5; }, cap: function () { return 5; },
    render: function (g, W, H, st, preview) {
      var m = W * 0.07, G = W - 2 * m, gap = W * 0.022, t = (G - 4 * gap) / 5;
      var titleB = W * 0.07, lineGap = W * 0.05, labB = W * 0.045, subB = W * 0.075;
      var total = titleB + W * 0.04 + t + lineGap + labB + subB, top = Math.max(H * 0.05, (H - total) / 2);
      var y = top + titleB, slots = [];
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.title, 'SIZE ' + SCRIPT, W * 0.07, W / 2, y, G);
      y += W * 0.04;
      for (var i = 0; i < 5; i++) { var s = slot(m + i * (t + gap), y, t, t, i, i); box(g, st, s, preview); slots.push(s); }
      var ly = y + t + lineGap;
      g.strokeStyle = st.colour.h; g.lineWidth = Math.max(2, W * 0.003);
      g.beginPath(); g.moveTo(m, ly); g.lineTo(W - m, ly); g.stroke();
      for (var j = 0; j < 5; j++) {
        var cx = m + j * (t + gap) + t / 2;
        g.fillStyle = st.colour.h; g.beginPath(); g.arc(cx, ly, W * 0.008, 0, Math.PI * 2); g.fill();
        line(g, st.v['y' + (j + 1)], '600 SIZE ' + SERIF, W * 0.026, cx, ly + labB, t);
      }
      line(g, st.v.sub.toUpperCase(), '600 SIZE ' + SERIF, W * 0.024, W / 2, ly + labB + subB, G, st.colour.h);
      return slots;
    }
  });
  TPL.push({
    id: 'lyrics', name: 'Song lyrics print', hint: '1 photo and your song', sizes: PORTRAIT, orient: 'v',
    lead: 'Your photo with the words of your song, your names and your date. Portrait, 30×40, 40×50 or 50×70 cm.',
    fields: [
      { k: 'song', l: 'Song title', v: 'Can You Feel the Love Tonight', max: 40 },
      { k: 'l1', l: 'Lyric line 1', v: 'There’s a calm surrender', max: 48 },
      { k: 'l2', l: 'Lyric line 2', v: 'to the rush of day', max: 48 },
      { k: 'l3', l: 'Lyric line 3', v: 'When the heat of a rolling wind', max: 48 },
      { k: 'l4', l: 'Lyric line 4', v: 'can be turned away', max: 48 },
      { k: 'names', l: 'Names', v: 'Sarah & James', max: 32 },
      { k: 'date', l: 'Date', v: '14 June 2019', max: 24 }
    ],
    need: function () { return 1; }, cap: function () { return 1; },
    render: function (g, W, H, st, preview) {
      var m = W * 0.12, cw = W - 2 * m, ph = cw * 0.78, fs = W * 0.036;
      var total = ph + W * 0.145 + 4 * fs * 1.5 + W * 0.165, top = Math.max(H * 0.05, (H - total) / 2);
      var s0 = slot(m, top, cw, ph, 0, 0); box(g, st, s0, preview);
      var y = top + ph + W * 0.08;
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.song.toUpperCase(), '600 SIZE ' + SERIF, W * 0.026, W / 2, y, cw, st.colour.h);
      y += W * 0.065;
      ['l1', 'l2', 'l3', 'l4'].forEach(function (k) { if (st.v[k]) line(g, st.v[k], 'italic 400 SIZE ' + SERIF, fs, W / 2, y, cw); y += fs * 1.5; });
      heart(g, W / 2, y + W * 0.005, W * 0.014, st.colour.h);
      y += W * 0.09;
      line(g, st.v.names, 'SIZE ' + SCRIPT, W * 0.07, W / 2, y, cw);
      line(g, st.v.date.toUpperCase(), '600 SIZE ' + SERIF, W * 0.024, W / 2, y + W * 0.065, cw, st.colour.h);
      return [s0];
    }
  });
  TPL.push({
    id: 'reasons', name: 'Reasons I love you', hint: '1 photo and 6 reasons', sizes: PORTRAIT, orient: 'v',
    lead: 'A photo and six reasons you love them, numbered. Portrait, 30×40, 40×50 or 50×70 cm.',
    fields: [
      { k: 'title', l: 'Title', v: 'Reasons I love you, Mum', max: 32 },
      { k: 'r1', l: 'Reason 1', v: 'Your smile lights up every room', max: 44 },
      { k: 'r2', l: 'Reason 2', v: 'You always know what to say', max: 44 },
      { k: 'r3', l: 'Reason 3', v: 'Your Sunday roasts', max: 44 },
      { k: 'r4', l: 'Reason 4', v: 'You never stop believing in us', max: 44 },
      { k: 'r5', l: 'Reason 5', v: 'Your terrible jokes', max: 44 },
      { k: 'r6', l: 'Reason 6', v: 'You are the heart of our family', max: 44 },
      { k: 'from', l: 'From', v: 'Love, Charlotte & Jemma', max: 40 }
    ],
    need: function () { return 1; }, cap: function () { return 1; },
    render: function (g, W, H, st, preview) {
      var m = W * 0.12, cw = W - 2 * m, ps = cw * 0.62, rowH = W * 0.058;
      var total = W * 0.08 + W * 0.04 + ps + W * 0.06 + 6 * rowH + W * 0.08, top = Math.max(H * 0.05, (H - total) / 2);
      var y = top + W * 0.08;
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.title, 'SIZE ' + SCRIPT, W * 0.075, W / 2, y, cw);
      y += W * 0.04;
      var s0 = slot((W - ps) / 2, y, ps, ps, 0, 0); box(g, st, s0, preview);
      y += ps + W * 0.075;
      var nx = m + cw * 0.06, tx = nx + W * 0.06;
      for (var i = 1; i <= 6; i++) {
        var r = st.v['r' + i]; if (!r) continue;
        g.textAlign = 'center'; line(g, String(i), '700 SIZE ' + SANS, W * 0.03, nx, y, W * 0.05, st.colour.h);
        g.textAlign = 'left'; line(g, r, '400 SIZE ' + SERIF, W * 0.03, tx, y, W - m - tx);
        y += rowH;
      }
      g.textAlign = 'center';
      line(g, st.v.from, 'italic 400 SIZE ' + SERIF, W * 0.03, W / 2, y + W * 0.035, cw, st.colour.h);
      return [s0];
    }
  });
  TPL.push({
    id: 'birth', name: 'Birth announcement', hint: '1 photo and the birth details', sizes: PORTRAIT, orient: 'v',
    lead: 'Your baby’s photo, name and birth details. Portrait, 30×40, 40×50 or 50×70 cm.',
    fields: [
      { k: 'head', l: 'Heading', v: 'Welcome to the world', max: 28 },
      { k: 'name', l: 'Baby’s name', v: 'Ella Rose', max: 28 },
      { k: 'date', l: 'Date of birth', v: '3 June 2024', max: 24 },
      { k: 'time', l: 'Time', v: '04:12', max: 10 },
      { k: 'weight', l: 'Weight', v: '3.2 kg', max: 12 },
      { k: 'length', l: 'Length', v: '50 cm', max: 12 },
      { k: 'place', l: 'Place', v: 'Maidstone', max: 20 }
    ],
    need: function () { return 1; }, cap: function () { return 1; },
    render: function (g, W, H, st, preview) {
      var m = W * 0.1, cw = W - 2 * m, ph = cw * 0.82;
      var total = W * 0.045 + W * 0.035 + ph + W * 0.12 + W * 0.06 + W * 0.15, top = Math.max(H * 0.05, (H - total) / 2);
      var y = top + W * 0.045;
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.head.toUpperCase(), '600 SIZE ' + SERIF, W * 0.036, W / 2, y, cw, st.colour.h);
      y += W * 0.035;
      var s0 = slot(m, y, cw, ph, 0, 0); box(g, st, s0, preview);
      y += ph + W * 0.12;
      line(g, st.v.name, 'SIZE ' + SCRIPT, W * 0.1, W / 2, y, cw);
      y += W * 0.06;
      line(g, st.v.date.toUpperCase(), '600 SIZE ' + SERIF, W * 0.03, W / 2, y, cw);
      y += W * 0.08;
      var stats = [['TIME', st.v.time], ['WEIGHT', st.v.weight], ['LENGTH', st.v.length], ['PLACE', st.v.place]], cw4 = cw / 4;
      stats.forEach(function (x, i) {
        var cx = m + cw4 * i + cw4 / 2;
        line(g, x[0], '700 SIZE ' + SANS, W * 0.018, cx, y, cw4 * 0.9, st.colour.h);
        line(g, x[1], '400 SIZE ' + SERIF, W * 0.03, cx, y + W * 0.045, cw4 * 0.92);
        if (i) { g.fillStyle = st.colour.h; g.fillRect(m + cw4 * i, y - W * 0.025, Math.max(1, W * 0.002), W * 0.08); }
      });
      return [s0];
    }
  });
  TPL.push({
    id: 'news', name: 'Birthday newspaper', hint: '1 photo and your story', sizes: PORTRAIT, orient: 'v',
    lead: 'A front page all about them, with your photo and story. Portrait, 30×40, 40×50 or 50×70 cm.',
    fields: [
      { k: 'paper', l: 'Newspaper name', v: 'The Daily News', max: 24 },
      { k: 'edition', l: 'Date line', v: 'Special edition  •  12 March 2026', max: 44 },
      { k: 'head', l: 'Headline', v: 'Born in 1980', max: 24 },
      { k: 'sub', l: 'Photo caption', v: 'Emily turns 45 and the whole town celebrates', max: 60 },
      { k: 'story', l: 'Story', v: 'Local legend Emily marks another year of laughter, kindness and questionable dance moves. Friends and family report that she has not aged a day, and that cake will be served all weekend.', max: 260 }
    ],
    need: function () { return 1; }, cap: function () { return 1; },
    render: function (g, W, H, st, preview) {
      var m = W * 0.08, cw = W - 2 * m, ph = cw * 0.6, y = Math.max(H * 0.05, H * 0.06);
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      y += W * 0.08;
      line(g, st.v.paper.toUpperCase(), '400 SIZE ' + HEAVY, W * 0.085, W / 2, y, cw, INK);
      y += W * 0.025;
      g.fillStyle = INK; g.fillRect(m, y, cw, Math.max(2, W * 0.004)); g.fillRect(m, y + W * 0.009, cw, Math.max(1, W * 0.0015));
      y += W * 0.045;
      line(g, st.v.edition.toUpperCase(), '600 SIZE ' + SANS, W * 0.02, W / 2, y, cw, st.colour.h);
      y += W * 0.018;
      g.fillStyle = INK; g.fillRect(m, y, cw, Math.max(1, W * 0.0015));
      y += W * 0.11;
      line(g, st.v.head.toUpperCase(), '400 SIZE ' + HEAVY, W * 0.095, W / 2, y, cw, INK);
      y += W * 0.035;
      var s0 = slot(m, y, cw, ph, 0, 0); box(g, st, s0, preview);
      y += ph + W * 0.045;
      line(g, st.v.sub, 'italic 400 SIZE ' + SERIF, W * 0.03, W / 2, y, cw);
      y += W * 0.035;
      g.fillStyle = INK; g.fillRect(m, y, cw, Math.max(1, W * 0.0015));
      /* the story in two columns */
      var colW = (cw - W * 0.04) / 2, fs = W * 0.027, lh = fs * 1.45, maxRows = Math.max(1, Math.floor((H - y - H * 0.05) / lh) - 1);
      g.font = '400 ' + Math.round(fs) + 'px ' + SERIF; g.textAlign = 'left'; g.fillStyle = INK;
      var rows = wrapText(g, st.v.story, colW, maxRows * 2), half = Math.ceil(rows.length / 2);
      rows.forEach(function (r, i) { var c = i < half ? 0 : 1; g.fillText(r, m + c * (colW + W * 0.04), y + W * 0.045 + (i % half) * lh); });
      g.textAlign = 'center';
      return [s0];
    }
  });
  TPL.push({
    id: 'ftree', name: 'Family tree', hint: '7 photos and your names', sizes: SQUARE, orient: 's',
    lead: 'Grandparents, parents and children in round photos, joined like a family tree. Square, 30×30 or 50×50 cm.',
    fields: [
      { k: 'title', l: 'Title', v: 'The Johnson Family', max: 28 },
      { k: 'names', l: 'Names in order, separate with commas', v: 'Grandad, Grandma, Dad, Mum, Emily, Jack, Lucy', max: 90 },
      { k: 'est', l: 'Line under the title', v: 'Est. 1985', max: 24 }
    ],
    need: function () { return 7; }, cap: function () { return 7; },
    render: function (g, W, H, st, preview) {
      var d = W * 0.15, nm = st.v.names.split(',').map(function (s) { return s.trim(); }), slots = [];
      var rowY = [H * 0.25, H * 0.49, H * 0.73], k = 0;
      var rows = [[W * 0.37, W * 0.63], [W * 0.37, W * 0.63], [W * 0.24, W * 0.5, W * 0.76]];
      g.strokeStyle = st.colour.h; g.lineWidth = Math.max(2, W * 0.004);
      /* couples joined, and a line down from each couple to the next row */
      [0, 1].forEach(function (r) {
        var a = rows[r][0], b = rows[r][1], cy = rowY[r] + d / 2, mid = (a + b) / 2, ny = rowY[r + 1] - W * 0.02;
        g.beginPath(); g.moveTo(a, cy); g.lineTo(b, cy); g.moveTo(mid, cy); g.lineTo(mid, ny); g.stroke();
        var xs = rows[r + 1];
        g.beginPath(); g.moveTo(xs[0], ny); g.lineTo(xs[xs.length - 1], ny); g.stroke();
        xs.forEach(function (x) { g.beginPath(); g.moveTo(x, ny); g.lineTo(x, rowY[r + 1]); g.stroke(); });
      });
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      rows.forEach(function (xs, r) {
        xs.forEach(function (x) {
          var s = slot(x - d / 2, rowY[r], d, d, k, k); roundBox(g, st, s, preview); slots.push(s);
          if (nm[k]) line(g, nm[k], '600 SIZE ' + SANS, W * 0.022, x, rowY[r] + d + W * 0.032, d * 1.3);
          k++;
        });
      });
      line(g, st.v.title, 'SIZE ' + SCRIPT, W * 0.075, W / 2, H * 0.12, W * 0.84);
      line(g, st.v.est.toUpperCase(), '600 SIZE ' + SERIF, W * 0.024, W / 2, H * 0.17, W * 0.84, st.colour.h);
      return slots;
    }
  });
  TPL.push({
    id: 'firstyear', name: 'Baby’s first year', hint: '12 photos, one for each month', sizes: SQUARE, orient: 's',
    lead: 'Twelve photos from newborn to one year old. Square, 30×30 or 50×50 cm.',
    fields: [
      { k: 'title', l: 'Title', v: 'My first year', max: 24 },
      { k: 'name', l: 'Baby’s name', v: 'Oliver James', max: 32 },
      { k: 'msg', l: 'Line at the bottom', v: 'Born 3 June 2025', max: 56 }
    ],
    need: function () { return 12; }, cap: function () { return 12; },
    render: function (g, W, H, st, preview) {
      var G = W * 0.74, gap = W * 0.018, t = (G - 3 * gap) / 4, lab = W * 0.034, row = t + lab + W * 0.012;
      var gy = W * 0.17, x0 = (W - G) / 2, slots = [];
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.title, 'SIZE ' + SCRIPT, W * 0.075, W / 2, W * 0.12, W * 0.84);
      for (var i = 0; i < 12; i++) {
        var x = x0 + (i % 4) * (t + gap), y = gy + Math.floor(i / 4) * row;
        var s = slot(x, y, t, t, i, i); box(g, st, s, preview); slots.push(s);
        line(g, (i + 1) + (i ? ' MONTHS' : ' MONTH'), '600 SIZE ' + SANS, W * 0.016, x + t / 2, y + t + lab * 0.72, t, st.colour.h);
      }
      var ty = gy + 3 * row + W * 0.05;
      line(g, st.v.name.toUpperCase(), '600 SIZE ' + SERIF, W * 0.034, W / 2, ty, W * 0.84, st.colour.h);
      line(g, st.v.msg, 'italic 400 SIZE ' + SERIF, W * 0.026, W / 2, ty + W * 0.045, W * 0.84);
      return slots;
    }
  });
  TPL.push({
    id: 'grid', name: 'Photo grid poster', hint: '9 photos and your names', sizes: PORTRAIT, orient: 'v',
    lead: 'Nine photos in a neat grid, with your names and date under them. Portrait, 30×40, 40×50 or 50×70 cm.',
    fields: [
      { k: 'names', l: 'Names', v: 'Oliver & Sophia', max: 32 },
      { k: 'date', l: 'Date or line under the names', v: '24.06.2026', max: 32 }
    ],
    need: function () { return 9; }, cap: function () { return 9; },
    render: function (g, W, H, st, preview) {
      var m = W * 0.1, G = W - 2 * m, gap = W * 0.018, t = (G - 2 * gap) / 3, th = t * 1.18, gh = 3 * th + 2 * gap;
      var total = gh + W * 0.2, top = Math.max(H * 0.05, (H - total) / 2), slots = [];
      for (var i = 0; i < 9; i++) { var s = slot(m + (i % 3) * (t + gap), top + Math.floor(i / 3) * (th + gap), t, th, i, i); box(g, st, s, preview); slots.push(s); }
      var y = top + gh + W * 0.11;
      g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      line(g, st.v.names, 'SIZE ' + SCRIPT, W * 0.08, W / 2, y, G);
      line(g, st.v.date.toUpperCase(), '600 SIZE ' + SERIF, W * 0.026, W / 2, y + W * 0.06, G, st.colour.h);
      return slots;
    }
  });
  var STATE = {};
  TPL.forEach(function (t) {
    var v = {}; t.fields.forEach(function (f) { v[f.k] = f.v; });
    var cap = t.max || (t.id === 'letters' ? 12 : t.cap());
    STATE[t.id] = { v: v, colour: (t.colours || COLOURS)[0], bg: BGS[0], photos: new Array(cap).fill(null), uploads: new Array(cap).fill(null), done: false, ratio: 1 };
  });
  function tplByName(n) { return TPL.filter(function (t) { return t.name === n; })[0] || null; }
  function typeByLabel(l) { return TYPES.filter(function (x) { return x.label && x.label === l; })[0] || null; }

  /* ---- fonts ---- */
  var fl = document.createElement('link');
  fl.rel = 'stylesheet';
  fl.href = 'https://fonts.googleapis.com/css2?family=Archivo+Black&family=Great+Vibes&family=Montserrat:wght@400;700&family=Playfair+Display:wght@400;600&display=swap';
  document.head.appendChild(fl);
  function fontsReady() {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return Promise.all([document.fonts.load('600 40px "Playfair Display"'), document.fonts.load('400 40px "Playfair Display"'),
      document.fonts.load('40px "Great Vibes"'), document.fonts.load('40px "Archivo Black"'), document.fonts.load('700 40px Montserrat'), document.fonts.load('400 40px Montserrat')]).catch(function () {});
  }

  var css = document.createElement('style');
  css.textContent = '.gapp{position:fixed;inset:0;z-index:10050;background:#F5F2EF;display:flex;flex-direction:column;font-family:Inter,"Helvetica Neue",Arial,sans-serif;color:#1E1B18}'
    + '.gapp[hidden]{display:none}'
    + 'html.gapp-tpl .gapai{display:none!important}'
    + '.gapp-ttl{visibility:hidden;position:relative}.gapp-ttl::after{content:attr(data-gapp-n);visibility:visible;position:absolute;left:0;top:0;white-space:nowrap}'
    + '.gapp__top{display:flex;align-items:center;gap:10px;padding:10px 12px;flex:none}'
    + '.gapp__top h2{flex:1;margin:0;font-size:17px;font-weight:700}'
    + '.gapp__back{height:40px;padding:0 14px 0 10px;border:0;border-radius:4px;background:#fff;font:inherit;font-weight:700;font-size:15px;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,.15)}'
    + '.gapp__done{height:40px;padding:0 18px;border:0;border-radius:4px;background:#FF8C3A;color:#fff;font:inherit;font-weight:700;font-size:15px;cursor:pointer}'
    + '.gapp__done[disabled]{background:#c9c5c0;cursor:not-allowed}'
    + '.gapp__body{flex:1;min-height:0;display:flex;flex-direction:column}'
    + '.gapp__view{flex:0 0 46%;min-height:0;display:flex;align-items:center;justify-content:center;padding:4px 12px}'
    + '.gapp__view canvas{max-width:100%;max-height:100%;box-shadow:0 8px 24px rgba(0,0,0,.18);touch-action:none;cursor:pointer;background:' + PAPER + '}'
    + '.gapp__ctl{flex:1;min-height:0;overflow-y:auto;background:#fff;border-radius:4px 4px 0 0;padding:12px 16px 20px;display:flex;flex-direction:column;gap:12px}'
    + '.gapp__ctl label{display:flex;flex-direction:column;gap:4px;font-size:12px;font-weight:600;color:#6F6A63}'
    + '.gapp__ctl input[type=text]{font:inherit;font-size:16px;color:#1E1B18;padding:9px 10px;border:2px solid #E0DDD8;border-radius:4px;width:100%;box-sizing:border-box}'
    + '.gapp__add{height:46px;border:0;border-radius:4px;background:#FF8C3A;color:#fff;font:inherit;font-weight:700;font-size:15px;cursor:pointer}'
    + '.gapp__add.is-full{background:#fff;color:#C8401A;border:2px solid #E0DDD8}'
    + '.gapp__hint{margin:0;font-size:12px;color:#6F6A63}'
    + '.gapp__sw{display:flex;gap:6px;flex-wrap:wrap}.gapp__sw button{flex:1 1 0;min-width:0;height:44px;padding:0 4px;border:2px solid #E0DDD8;border-radius:4px;background:#fff;font:inherit;font-size:12px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:5px}'
    + '.gapp__sw i{flex:none;width:14px;height:14px;border-radius:3px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.25)}[data-bgs] button{flex:1 1 30%}.gapp__sw button[aria-checked=true]{border-color:#C8401A;color:#C8401A}'
    + '@keyframes gapPostPulse{0%,100%{box-shadow:0 0 0 0 rgba(255,140,58,.9)}50%{box-shadow:0 0 0 10px rgba(255,140,58,0)}}'
    + '.gapp__add:not(.is-full),.gapp__done:not([disabled]){animation:gapPostPulse 1s ease-in-out infinite}'
    + '@media (prefers-reduced-motion:reduce){.gapp__add,.gapp__done{animation:none!important}}'
    + '@media (min-width:900px){.gapp__body{flex-direction:row}.gapp__view{flex:1 1 auto;padding:16px}.gapp__ctl{flex:0 0 420px;border-radius:0;border-left:1px solid #E2DDD5}}'
    + '.gapp-type{display:flex;gap:6px;justify-content:center;padding:6px 12px 0}.gapp-type[hidden]{display:none}'
    + '.gapp-type button{height:34px;padding:0 12px;border:2px solid #E0DDD8;border-radius:4px;background:#fff;font:inherit;font-size:13px;font-weight:600;color:#1E1B18;cursor:pointer}'
    + '.gapp-type button[aria-checked=true]{border-color:#C8401A;background:#C8401A;color:#fff}'
    /* phones: the four product buttons share one row */
    + '@media (max-width:899px){.gapp-type button{flex:1 1 0;min-width:0;padding:0 4px;font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}}'
    /* desktop: the configurator is a grid, so the switch sits over the top of the preview area */
    + '@media (min-width:900px){[data-gapcfg] .gapp-type{grid-area:stage;align-self:start;justify-self:center;position:relative;z-index:2;padding-top:16px}}'
    /* product lists: the name and price always show under the square picture (iPhone Safari squeezed them out) */
    + '[data-gapcfg] .gapcfg__grid.is-list{flex:0 0 auto!important;height:auto!important;align-items:stretch!important}'
    + '[data-gapcfg] .gapcfg__grid.is-list .gapcfg__pcard{height:auto!important;min-height:0!important;overflow:visible!important}'
    + '[data-gapcfg] .gapcfg__grid.is-list .gapcfg__thumb{position:relative;flex:none!important;aspect-ratio:auto!important;height:0!important;padding-bottom:100%!important}'
    + '[data-gapcfg] .gapcfg__grid.is-list .gapcfg__thumb img,[data-gapcfg] .gapcfg__grid.is-list .gapcfg__thumb .gapcfg__mock{position:absolute;left:0;top:0}'
    /* first step after a template card: which product */
    + '.gapp-pick{position:fixed;inset:0;z-index:10050;background:#F5F2EF;display:flex;flex-direction:column;align-items:center;padding:12px 16px;overflow-y:auto;font-family:Inter,"Helvetica Neue",Arial,sans-serif;color:#1E1B18}'
    + '.gapp-pick[hidden]{display:none}.gapp-pick__top{width:100%;max-width:560px;display:flex;align-items:center;gap:10px}'
    + '.gapp-pick__top h2{margin:0;font-size:18px;font-weight:700}.gapp-pick__lead{width:100%;max-width:560px;margin:14px 0 10px;font-size:14px;color:#6F6A63}'
    + '.gapp-pick__list{width:100%;max-width:560px;display:flex;flex-direction:column;gap:10px}'
    + '.gapp-pick__list button{display:flex;align-items:center;gap:12px;text-align:left;padding:14px;border:2px solid #E0DDD8;border-radius:4px;background:#fff;color:#1E1B18;font:inherit;cursor:pointer}'
    + '.gapp-pick__list button:hover{border-color:#C8401A}.gapp-pick__list b{display:block;font-size:16px}.gapp-pick__list span{display:block;font-size:13px;color:#6F6A63;margin-top:2px}'
    + '.gapp-pick__list i{font-style:normal;margin-left:auto;font-weight:700;color:#C8401A;white-space:nowrap}'
    + '.gapp-pick__ic{display:block;flex:none;width:76px;height:76px;border-radius:4px;background:#EFEBE6 center/cover no-repeat}'
    + '.gapp-pick__ic.f{background-image:url(https://cdn.shopify.com/s/files/1/0901/8241/8812/files/0-trafalgar-square-lion-big-ben-framed-square-art-photography-print-50x50-black.jpg?width=200)}.gapp-pick__ic.d{background-image:url(https://cdn.shopify.com/s/files/1/0901/8241/8812/files/print-on-dibond1_158f8166-0bdc-4dcf-ae3e-65e55d7b77aa.jpg?width=200)}.gapp-pick__ic.c{background-image:url(https://cdn.shopify.com/s/files/1/0901/8241/8812/files/canvas_datail.jpg?width=200)}.gapp-pick__ic.a{background-image:url(https://cdn.shopify.com/s/files/1/0901/8241/8812/files/Hahnemuhle-Fine-Art-Print-2.jpg?width=200)}';
  document.head.appendChild(css);

  /* ---- the editor ---- */
  var ov = document.createElement('div');
  ov.className = 'gapp'; ov.hidden = true; ov.setAttribute('role', 'dialog');
  ov.innerHTML = '<div class="gapp__top"><button type="button" class="gapp__back">‹ Back</button><h2>Design your poster</h2>'
    + '<button type="button" class="gapp__done" disabled>Done</button></div>'
    + '<div class="gapp__body"><div class="gapp__view"><canvas aria-label="Your poster preview. Tap a photo box to change it, drag a photo onto another box to swap them."></canvas></div>'
    + '<div class="gapp__ctl">'
    + '<button type="button" class="gapp__add">Add photos</button><p class="gapp__hint">One photo goes in each box. Tap a box to choose its photo, drag a photo onto another box to swap them.</p>'
    + '<div class="gapp__fields" style="display:flex;flex-direction:column;gap:12px"></div>'
    + '<div><div class="gapp__hint" style="margin-bottom:6px;font-weight:600">Background colour</div><div class="gapp__sw" role="radiogroup" aria-label="Background colour" data-bgs></div></div>'
    + '<div><div class="gapp__hint" style="margin-bottom:6px;font-weight:600">Accent colour</div><div class="gapp__sw" role="radiogroup" aria-label="Accent colour"></div></div>'
    + '</div></div>'
    + '<input type="file" accept="image/jpeg,image/png,image/webp" multiple hidden data-pmany><input type="file" accept="image/jpeg,image/png,image/webp" hidden data-pone>';
  function mount() { if (!ov.parentNode) document.body.appendChild(ov); if (!pick.parentNode) document.body.appendChild(pick); }

  var cv = ov.querySelector('canvas'), many = ov.querySelector('[data-pmany]'), one = ov.querySelector('[data-pone]');
  var doneBtn = ov.querySelector('.gapp__done'), addBtn = ov.querySelector('.gapp__add'), sw = ov.querySelector('.gapp__sw:not([data-bgs])'), bgSw = ov.querySelector('[data-bgs]'), fieldsEl = ov.querySelector('.gapp__fields');
  var ACT = null; /* the open template and product type: { tpl, type } */
  function T() { return ACT && ACT.tpl; }
  function ST() { return ACT && STATE[ACT.tpl.id]; }

  /* the accent colours: a template can bring its own (Christmas reds and greens, Halloween orange and black) */
  function colsOf(t) { return t.colours || COLOURS; }
  function buildSw() {
    sw.innerHTML = '';
    colsOf(T()).forEach(function (c) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'radio');
      b.innerHTML = '<i></i>'; b.firstChild.style.background = c.h; b.appendChild(document.createTextNode(c.n));
      b.addEventListener('click', function () { ST().colour = c; syncSw(); draw(); });
      sw.appendChild(b);
    });
  }
  BGS.forEach(function (c) {
    var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'radio');
    b.innerHTML = '<i></i>'; b.firstChild.style.background = c.h; b.appendChild(document.createTextNode(c.n));
    b.addEventListener('click', function () { ST().bg = c; syncSw(); draw(); });
    bgSw.appendChild(b);
  });
  function syncSw() {
    [].forEach.call(sw.children, function (b, i) { b.setAttribute('aria-checked', String(colsOf(T())[i] === ST().colour)); });
    [].forEach.call(bgSw.children, function (b, i) { b.setAttribute('aria-checked', String(BGS[i] === ST().bg)); });
  }
  function buildFields() {
    var t = T(), st = ST();
    fieldsEl.innerHTML = '';
    t.fields.forEach(function (f) {
      var l = document.createElement('label'), i = document.createElement('input');
      l.textContent = f.l; i.type = 'text'; i.maxLength = f.max; i.value = st.v[f.k];
      if (f.letters) i.setAttribute('autocapitalize', 'characters');
      if (f.digits) i.setAttribute('inputmode', 'numeric');
      i.addEventListener('input', function () {
        if (f.letters) { i.value = i.value.toUpperCase().replace(/[^A-Z]/g, ''); }
        if (f.digits) { i.value = i.value.replace(/[^0-9]/g, ''); }
        st.v[f.k] = i.value; draw();
      });
      l.appendChild(i); fieldsEl.appendChild(l);
    });
  }

  function filled(st, t) { var n = 0; for (var i = 0; i < t.cap(st); i++) if (st.photos[i]) n++; return n; }
  function ready() {
    var t = T(), st = ST(), n = filled(st, t);
    if (t.repeat ? n < t.need(st) : n < t.cap(st)) return false;
    return t.fields.every(function (f) { return (!f.letters || st.v[f.k].length >= f.letters) && (!f.digits || st.v[f.k].length >= f.digits); });
  }

  /* ---- preview ---- */
  var lastSlots = [], drag = null;
  function draw() {
    if (ov.hidden || !ACT) return;
    var st = ST(), t = T(), box = cv.parentNode, bw = box.clientWidth - 24, bh = box.clientHeight - 8;
    var ar = previewRatio(t, st), w = Math.max(120, Math.min(bw, bh * ar)), h = w / ar, dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.style.width = Math.round(w) + 'px'; cv.style.height = Math.round(h) + 'px';
    cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
    var g = cv.getContext('2d');
    g.fillStyle = st.bg.h; g.fillRect(0, 0, cv.width, cv.height);
    lastSlots = t.render(g, cv.width, cv.height, st, true);
    /* while dragging onto another box: the photo being moved is faded, the box it will swap with is outlined */
    if (drag && drag.to) {
      var a = drag.from, b = drag.to, lw = Math.max(3, Math.min(b.w, b.h) * 0.04);
      g.fillStyle = 'rgba(255,255,255,.55)'; g.fillRect(a.x, a.y, a.w, a.h);
      g.strokeStyle = '#FF8C3A'; g.lineWidth = lw; g.strokeRect(b.x + lw / 2, b.y + lw / 2, b.w - lw, b.h - lw);
    }
    var n = filled(st, t), need = t.need(st), cap = t.cap(st);
    addBtn.textContent = n >= cap ? 'Change photos' : (n < need ? (n ? 'Add ' + (need - n) + ' more photo' + (need - n > 1 ? 's' : '') : 'Add ' + (need === cap ? need : need + '–' + cap) + ' photos') : 'Add more photos (' + n + ' of ' + cap + ')');
    addBtn.classList.toggle('is-full', n >= need);
    doneBtn.disabled = !ready();
  }
  window.addEventListener('resize', draw);
  /* the poster's shape in the editor: the chosen size, or the new layout's first size when the typed number changes it */
  function previewRatio(t, st) {
    if (ACT && orientOf(t) !== ACT.orient) { var z = sizesOf(t)[0]; return z[0] / z[1]; }
    return st.ratio;
  }

  function loadImg(f) {
    return new Promise(function (ok, fail) {
      var u = URL.createObjectURL(f), im = new Image();
      im.onload = function () { ok({ img: im, file: f, x: 50, y: 50 }); };
      im.onerror = fail; im.src = u;
    });
  }
  function setPhoto(st, i, f) { return loadImg(f).then(function (p) { st.photos[i] = p; st.uploads[i] = null; }).catch(function () {}); }
  addBtn.addEventListener('click', function () { many.value = ''; many.click(); });
  many.addEventListener('change', function () {
    var st = ST(), t = T(), cap = t.cap(st), files = [].slice.call(many.files || []), jobs = [];
    if (filled(st, t) >= cap) for (var j = 0; j < cap; j++) { st.photos[j] = null; st.uploads[j] = null; }
    for (var i = 0; i < cap && files.length; i++) if (!st.photos[i]) jobs.push(setPhoto(st, i, files.shift()));
    Promise.all(jobs).then(draw);
  });
  var target = -1;
  one.addEventListener('change', function () { var f = one.files && one.files[0]; if (f && target > -1) setPhoto(ST(), target, f).then(draw); });

  /* tap a box to choose its photo; drag inside the box to move the photo, or drop it on another box to swap */
  function inPoly(pts, x, y) {
    var inside = false;
    for (var i = 0, j = pts.length - 1; i < pts.length; j = i++) {
      var a = pts[i], b = pts[j];
      if ((a[1] > y) !== (b[1] > y) && x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0]) inside = !inside;
    }
    return inside;
  }
  function slotAt(e) {
    var r = cv.getBoundingClientRect(), k = cv.width / r.width, x = (e.clientX - r.left) * k, y = (e.clientY - r.top) * k;
    for (var i = 0; i < lastSlots.length; i++) { var s = lastSlots[i]; if (x >= s.x && x <= s.x + s.w && y >= s.y && y <= s.y + s.h && (!s.poly || inPoly(s.poly, x, y))) return s; }
    return null;
  }
  cv.addEventListener('pointerdown', function (e) {
    var s = slotAt(e); if (!s) return;
    var ph = s.p > -1 ? ST().photos[s.p] : null;
    drag = { from: s, to: null, x: e.clientX, y: e.clientY, moved: false, px: ph ? ph.x : 50, py: ph ? ph.y : 50 };
    cv.setPointerCapture(e.pointerId);
  });
  cv.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    if (Math.abs(dx) + Math.abs(dy) > 6) drag.moved = true;
    var s = drag.from, ph = s.p > -1 ? ST().photos[s.p] : null; if (!ph || !drag.moved) return;
    var over = slotAt(e);
    if (!over || over.k !== s.k) {
      /* left its own box: the photo keeps its place and the drop target is shown */
      ph.x = drag.px; ph.y = drag.py; drag.to = over && over.p !== s.p ? over : null;
      draw(); return;
    }
    drag.to = null;
    var r = cv.getBoundingClientRect(), f = r.width / cv.width, sw2 = s.w * f, sh = s.h * f;
    var k = Math.max(sw2 / ph.img.naturalWidth, sh / ph.img.naturalHeight), ox = ph.img.naturalWidth * k - sw2, oy = ph.img.naturalHeight * k - sh;
    if (ox > 1) ph.x = Math.max(0, Math.min(100, drag.px - dx / ox * 100));
    if (oy > 1) ph.y = Math.max(0, Math.min(100, drag.py - dy / oy * 100));
    draw();
  });
  function endDrag() {
    var d = drag; drag = null;
    if (!d) return;
    var st = ST(), s = d.from;
    if (!d.moved) {
      /* an empty box of a repeating template (the heart) asks for more photos; any other box gets its own photo */
      if (s.p < 0) { many.value = ''; many.click(); return; }
      target = s.p; one.value = ''; one.click(); return;
    }
    if (d.to) {
      var a = s.p, b = d.to.p < 0 ? d.to.k : d.to.p;
      var t1 = st.photos[a]; st.photos[a] = st.photos[b]; st.photos[b] = t1;
      var u1 = st.uploads[a]; st.uploads[a] = st.uploads[b]; st.uploads[b] = u1;
    }
    draw();
  }
  cv.addEventListener('pointerup', endDrag); cv.addEventListener('pointercancel', function () { drag = null; draw(); });

  /* ---- the configurator side ---- */
  function q(s) { return document.querySelector(s); }
  function root() { return q('[data-gapcfg]'); }
  function title() { return q('[data-gapcfg] [data-title]'); }
  function active() {
    var t = title(), cfg = q('[data-gapcfg] [data-cfg]');
    if (!ACT || !t || !cfg || cfg.hidden) return false;
    var x = t.textContent.trim();
    return x === ACT.tpl.name || x === (ACT.type.label || '');
  }
  /* the configurator asks for each product's rules: template cards and the shared Dibond / Canvas cards */
  window.gapcfgRules = function (p) {
    var t = tplByName(p.label) || (typeByLabel(p.label) ? (T() || TPL[0]) : null);
    return t ? { sizes: sizesOf(t), orient: orientOf(t), hidePaper: true, edge: 'white' } : null;
  };

  var DATA = null;
  try { DATA = JSON.parse(q('[data-gapcfg-data]').textContent); } catch (e) {}
  function productFor(t, type) { var l = type.label || t.name; return DATA && DATA.products.filter(function (y) { return y.label === l && y.ok; })[0]; }
  /* the cheapest of the template's sizes on that product */
  function fromPrice(t, type) {
    var p = productFor(t, type); if (!p) return '';
    var si = -1; p.options.forEach(function (o, i) { if (/size/i.test(o.name)) si = i; });
    var best = 0;
    p.variants.forEach(function (v) {
      var m = /(\d+)\s*[x×]\s*(\d+)/i.exec(si > -1 ? v.o[si] : ''); if (!m || !v.available) return;
      var a = +m[1], b = +m[2];
      if ((t.allSizes || sizesOf(t)).some(function (z) { return (z[0] === a && z[1] === b) || (z[0] === b && z[1] === a); }) && (!best || v.price < best)) best = v.price;
    });
    /* the £10 art & design fee is added as its own cart line (gap-configurator-ai.js); the fine art poster product already includes it */
    if (best && type.id !== 'art') best += 1000;
    return best ? DATA.symbol + (best % 100 ? (best / 100).toFixed(2) : best / 100) : '';
  }
  function cardFor(label) {
    return [].filter.call(document.querySelectorAll('[data-gapcfg] .gapcfg__pcard'), function (c) { var n = c.querySelector('.gapcfg__pname'); return n && n.textContent === label; })[0];
  }
  var bypass = false;
  /* open a template on a product type: the design comes along when it is done, otherwise the box starts empty */
  function openCard(t, type) {
    var c = cardFor(type.label || t.name); if (!c) return;
    ACT = { tpl: t, type: type, orient: orientOf(t) };
    bypass = true; c.click(); bypass = false;
    var r = root(); if (r) r.dispatchEvent(new Event('gapcfg:clear'));
    var st = ST(); st.ratio = sizeRatio();
    if (st.done) feed();
    sync();
  }

  /* product choice shown when a template card is tapped */
  var pick = document.createElement('div');
  pick.className = 'gapp-pick'; pick.hidden = true; pick.setAttribute('role', 'dialog'); pick.setAttribute('aria-label', 'Choose your product');
  pick.innerHTML = '<div class="gapp-pick__top"><button type="button" class="gapp__back">‹ Back</button><h2></h2></div>'
    + '<p class="gapp-pick__lead"></p><div class="gapp-pick__list"></div>';
  pick.querySelector('.gapp__back').addEventListener('click', function () { pick.hidden = true; });
  function showPick(t) {
    pick.querySelector('h2').textContent = t.name;
    pick.querySelector('.gapp-pick__lead').textContent = t.lead + ' Choose how you would like it printed.';
    var list = pick.querySelector('.gapp-pick__list'); list.innerHTML = '';
    TYPES.forEach(function (x) {
      if (!productFor(t, x)) return;
      var b = document.createElement('button'); b.type = 'button';
      b.innerHTML = '<em class="gapp-pick__ic ' + x.ic + '"></em><div><b></b><span></span></div><i></i>';
      b.querySelector('b').textContent = x.n; b.querySelector('span').textContent = x.d;
      var fp = fromPrice(t, x); b.querySelector('i').textContent = fp ? 'from ' + fp : '';
      b.addEventListener('click', function () { pick.hidden = true; openCard(t, x); });
      list.appendChild(b);
    });
    pick.hidden = false;
  }
  document.addEventListener('click', function (e) {
    if (bypass || !e.target.closest) return;
    var c = e.target.closest('[data-gapcfg] .gapcfg__pcard'), n = c && c.querySelector('.gapcfg__pname'), t = n && tplByName(n.textContent);
    if (!t) return;
    e.preventDefault(); e.stopImmediatePropagation();
    showPick(t);
  }, true);

  /* Framed / Dibond / Canvas / Fine art switch above the preview; the design stays, size and options start again */
  var bar = document.createElement('div');
  bar.className = 'gapp-type'; bar.hidden = true; bar.setAttribute('role', 'radiogroup'); bar.setAttribute('aria-label', 'Print on');
  TYPES.forEach(function (x) {
    var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'radio'); b.textContent = x.s || x.n;
    b.addEventListener('click', function () {
      if (!ACT || ACT.type === x) return;
      var back = q('[data-gapcfg] [data-back]'); if (back) back.click();
      openCard(ACT.tpl, x);
    });
    bar.appendChild(b);
  });

  /* the chosen size (as shown on the Size tab) sets the poster's shape */
  function sizeRatio() {
    var tab = [].filter.call(document.querySelectorAll('[data-gapcfg] .gapcfg__tab'), function (t) { var b = t.querySelector('b'); return b && /size/i.test(b.textContent); })[0];
    var m = tab && /(\d+(?:\.\d+)?)\s*×\s*(\d+(?:\.\d+)?)/.exec(tab.querySelector('small').textContent);
    return m ? +m[1] / +m[2] : 1;
  }
  /* each template card shows its own design filled with sample photos, drawn here (Uğur, 2026-10-28: the shared framed
     print picture said nothing about the template). The photos are the shop's own pictures on the Shopify CDN */
  var SAMPLES = ['Family-portrait.webp', 'couple_original_photo.jpg', 'kids_original_photo.jpg', 'baby_portrait.jpg', 'wedding_portrait.jpg',
    'Portrait_original_photo.jpg', 'german-shepherd-dog.webp'].map(function (f) { return 'https://cdn.shopify.com/s/files/1/0901/8241/8812/files/' + f + '?width=360'; });
  var samples = null, thumbBusy = false;
  function loadSamples() {
    if (!samples) samples = Promise.all(SAMPLES.map(function (u) {
      return new Promise(function (ok) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { ok(im); }; im.onerror = function () { ok(null); }; im.src = u; });
    })).then(function (l) { return l.filter(Boolean); });
    return samples;
  }
  function thumbOf(t, ims) {
    var z = sizesOf(t)[0], r = z[0] / z[1], st = { v: {}, colour: colsOf(t)[0], bg: BGS[0], photos: [] };
    t.fields.forEach(function (f) { st.v[f.k] = f.v; });
    for (var i = 0, n = t.cap(st); i < n; i++) st.photos.push({ img: ims[i % ims.length], x: 50, y: 50 });
    var H = 700, W = Math.round(H * r), pc = document.createElement('canvas'); pc.width = W; pc.height = H;
    var g = pc.getContext('2d'); g.fillStyle = st.bg.h; g.fillRect(0, 0, W, H);
    t.render(g, W, H, st, false);
    /* the poster in a thin black frame on a soft wall */
    var S = 480, c = document.createElement('canvas'); c.width = c.height = S;
    var o = c.getContext('2d'); o.fillStyle = '#EFEBE6'; o.fillRect(0, 0, S, S);
    var k = Math.min(S * 0.8 / W, S * 0.84 / H), pw = W * k, ph = H * k, fw = Math.max(5, S * 0.016), x = (S - pw) / 2, y = (S - ph) / 2;
    o.save(); o.shadowColor = 'rgba(0,0,0,.28)'; o.shadowBlur = 16; o.shadowOffsetY = 6;
    o.fillStyle = '#222'; o.fillRect(x - fw, y - fw, pw + 2 * fw, ph + 2 * fw); o.restore();
    o.drawImage(pc, x, y, pw, ph);
    return c.toDataURL('image/jpeg', 0.86);
  }
  function thumbs() {
    if (thumbBusy) return;
    var todo = [].filter.call(document.querySelectorAll('[data-gapcfg] .gapcfg__pcard'), function (c) {
      var n = c.querySelector('.gapcfg__pname'), im = c.querySelector('.gapcfg__thumb img');
      return n && im && tplByName(n.textContent) && im.getAttribute('data-gapp-src') !== n.textContent;
    });
    if (!todo.length) return;
    thumbBusy = true;
    Promise.all([loadSamples(), fontsReady()]).then(function (a) {
      var ims = a[0];
      if (ims.length) todo.forEach(function (c) {
        var n = c.querySelector('.gapcfg__pname').textContent, im = c.querySelector('.gapcfg__thumb img');
        try { im.src = thumbOf(tplByName(n), ims); im.removeAttribute('srcset'); im.setAttribute('data-gapp-src', n); } catch (e) {}
      });
      thumbBusy = false;
    });
  }
  /* only write when it changes, so the observer below does not wake itself */
  function setText(n, t) { if (n.textContent !== t) n.textContent = t; }
  var labelSaved = null;
  function sync() {
    var on = active(), st = q('[data-gapcfg] [data-start]');
    /* the shared Dibond / Canvas cards stay out of the list; template cards show their own "From" price */
    [].forEach.call(document.querySelectorAll('[data-gapcfg] .gapcfg__pcard'), function (c) {
      var n = c.querySelector('.gapcfg__pname'); if (!n) return;
      if (typeByLabel(n.textContent)) { if (c.style.display !== 'none') c.style.display = 'none'; return; }
      var t = tplByName(n.textContent), ps = t && c.querySelector('.gapcfg__psub'), fp = ps && fromPrice(t, TYPES[0]);
      if (fp) setText(ps, 'From ' + fp);
    });
    thumbs();
    var cfgEl = q('[data-gapcfg] [data-cfg]'), stage = q('[data-gapcfg] [data-stage]');
    if (cfgEl && stage && bar.parentNode !== cfgEl) cfgEl.insertBefore(bar, stage);
    if (bar.hidden === on) bar.hidden = !on;
    /* photo effects are for single-photo products only: hide them on every template and go back to Original */
    document.documentElement.classList.toggle('gapp-tpl', on);
    if (on) { var fx = q('.gapai .gapai__b[aria-pressed=true]'); if (fx && fx.textContent !== 'Original' && !fx.disabled) { var o0 = q('.gapai .gapai__b'); if (o0) o0.click(); } }
    [].forEach.call(bar.children, function (b, i) { var v = String(!!ACT && TYPES[i] === ACT.type); if (b.getAttribute('aria-checked') !== v) b.setAttribute('aria-checked', v); });
    /* Dibond / Canvas keep the shared card's title (other scripts read it to pick the frameless look); the template name is shown over it */
    var tt = title(), nm = on && ACT.type.label ? ACT.tpl.name : '';
    if (tt) {
      if (tt.classList.contains('gapp-ttl') !== !!nm) tt.classList.toggle('gapp-ttl', !!nm);
      if (nm && tt.getAttribute('data-gapp-n') !== nm) tt.setAttribute('data-gapp-n', nm);
    }
    if (st) {
      var lb = st.querySelector('.gapcfg__startlabel'), hn = st.querySelector('.gapcfg__hint');
      if (lb && labelSaved === null) labelSaved = [lb.textContent, hn ? hn.textContent : ''];
      if (lb) setText(lb, on ? 'Design your poster' : labelSaved[0]);
      if (hn) setText(hn, on ? ACT.tpl.hint : labelSaved[1]);
    }
    var ch = q('[data-gapcfg] [data-change]');
    if (ch) setText(ch, on ? 'Edit design' : 'Change photo');
    if (on && ST().done) {
      /* a new size: draw the poster again */
      var s = ST(), r = sizeRatio();
      if (Math.abs(r - s.ratio) > 0.001) { s.ratio = r; clearTimeout(sync.t); sync.t = setTimeout(feed, 250); }
    }
  }
  function open() {
    var t = T(), st = ST();
    st.ratio = sizeRatio();
    ov.querySelector('h2').textContent = t.name;
    ov.setAttribute('aria-label', 'Design your ' + t.name.toLowerCase());
    buildFields(); buildSw(); syncSw();
    ov.hidden = false; document.documentElement.style.overflow = 'hidden';
    fontsReady().then(draw); draw();
  }
  function close() { ov.hidden = true; document.documentElement.style.overflow = ''; }
  ov.querySelector('.gapp__back').addEventListener('click', close);
  document.addEventListener('click', function (e) {
    if (!active() || !e.target.closest) return;
    var b = e.target.closest('[data-gapcfg] [data-start], [data-gapcfg] [data-change]');
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (b.hasAttribute('data-start')) b.classList.add('is-tapped');
    open();
  }, true);

  /* Done: draw the poster at print quality (under 15 megapixels for iPhones) and hand it to the configurator as the photo */
  function feed() {
    var t = T(), st = ST(), r = st.ratio, H = Math.round(Math.sqrt(14500000 / r)), W = Math.round(H * r);
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    return fontsReady().then(function () {
      var g = c.getContext('2d'); g.fillStyle = st.bg.h; g.fillRect(0, 0, W, H);
      t.render(g, W, H, st, false);
      return new Promise(function (ok) { c.toBlob(ok, 'image/jpeg', 0.92); });
    }).then(function (blob) {
      var inp = q('[data-gapcfg] [data-file]'); if (!blob || !inp) return;
      var dt = new DataTransfer(); dt.items.add(new File([blob], t.id + '-poster.jpg', { type: 'image/jpeg' }));
      inp.files = dt.files; inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  doneBtn.addEventListener('click', function () {
    if (!ready()) return;
    var t = T(), st = ST();
    doneBtn.disabled = true; doneBtn.textContent = 'Saving…';
    st.done = true; st.ratio = sizeRatio();
    for (var i = 0; i < t.cap(st); i++) if (st.photos[i] && !st.uploads[i]) st.uploads[i] = upload(st.photos[i].file);
    if (orientOf(t) !== ACT.orient) {
      /* the typed number changed the layout (one digit portrait, two digits square): open the product again with its new sizes */
      var back = q('[data-gapcfg] [data-back]'); if (back) back.click();
      openCard(t, ACT.type); doneBtn.textContent = 'Done'; close(); return;
    }
    feed().then(function () { doneBtn.textContent = 'Done'; close(); draw(); });
  });

  /* the original photos go to the same upload folder as every order photo */
  function upload(f) {
    return new Promise(function (ok) {
      var fd = new FormData(); fd.append('file', f); fd.append('upload_preset', PRESET); fd.append('folder', 'giftlyartprint/orders');
      var x = new XMLHttpRequest(); x.open('POST', 'https://api.cloudinary.com/v1_1/' + CLOUD + '/image/upload', true);
      x.onload = function () { try { ok(JSON.parse(x.responseText).secure_url || ''); } catch (e) { ok(''); } };
      x.onerror = function () { ok(''); }; x.timeout = 180000; x.ontimeout = function () { ok(''); };
      x.send(fd);
    });
  }
  /* add the design's details to the cart line the configurator sends */
  var rawFetch = window.fetch;
  window.fetch = function (url, opt) {
    if (!(typeof url === 'string' && url.indexOf('/cart/add') > -1 && opt && typeof opt.body === 'string' && active() && ST().done)) return rawFetch.apply(this, arguments);
    var self = this, t = T(), st = ST(), list = [];
    for (var i = 0; i < t.cap(st); i++) if (st.photos[i]) list.push(st.uploads[i] || '');
    return Promise.all(list).then(function (urls) {
      try {
        var b = JSON.parse(opt.body), pr = b.items && b.items[0] && b.items[0].properties;
        if (pr) {
          pr['Product'] = t.name + ' – ' + ACT.type.n;
          pr['Poster Template'] = t.name;
          t.fields.forEach(function (f) { pr[f.l.replace(/\s*\(.*\)$/, '')] = st.v[f.k]; });
          pr['Background'] = st.bg.n;
          pr['Accent Colour'] = st.colour.n;
          urls.forEach(function (u, i) { pr['_Poster Photo ' + (i + 1)] = u || 'upload failed'; });
          opt = Object.assign({}, opt, { body: JSON.stringify(b) });
        }
      } catch (e) {}
      return rawFetch.call(self, url, opt);
    });
  };

  function watch() {
    mount();
    var g = root(); if (!g) return;
    new MutationObserver(sync).observe(g, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

